"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnnouncementLink = void 0;
const SITE_PATH = /^\/(?![/\\])\S*$/;
const SECURE_ADDRESS = /^https:\/\/\S+$/i;
const isAnnouncementLink = (link) => {
    if (SITE_PATH.test(link))
        return true;
    if (!SECURE_ADDRESS.test(link))
        return false;
    try {
        return new URL(link).hostname !== '';
    }
    catch {
        return false;
    }
};
exports.isAnnouncementLink = isAnnouncementLink;
